<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { show_agent_name_in_conversations } =
      currentAccount.value?.settings || {};
    isEnabled.value = !!show_agent_name_in_conversations;
  },
  { deep: true, immediate: true }
);

const updateAccountSettings = async settings => {
  try {
    await updateAccount(settings);
    useAlert(
      t('GENERAL_SETTINGS.FORM.SHOW_AGENT_NAME_IN_CONVERSATIONS.API.SUCCESS')
    );
  } catch (error) {
    useAlert(
      t('GENERAL_SETTINGS.FORM.SHOW_AGENT_NAME_IN_CONVERSATIONS.API.ERROR')
    );
  }
};

const toggleShowAgentName = async () => {
  return updateAccountSettings({
    show_agent_name_in_conversations: isEnabled.value,
  });
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.SHOW_AGENT_NAME_IN_CONVERSATIONS.TITLE')"
    :description="
      t('GENERAL_SETTINGS.FORM.SHOW_AGENT_NAME_IN_CONVERSATIONS.NOTE')
    "
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleShowAgentName" />
      </div>
    </template>
  </SectionLayout>
</template>
